import { DefaultColorPalette } from '@mui/joy/styles/types'

//export default ['#636B74', '#C41C1C', '#0B6BCB', '#1F7A1F', '#9A5B13']
export default ['neutral', 'danger', 'primary', 'success', 'warning'] as DefaultColorPalette[]
